module.exports = __webpack_public_path__ + "img/kt1.deeef68e.png";